(function(EF, undefined) {

  var ResponseSetCollection = Chaplin.Collection.extend({
    model: EF.Models.Evaluations.ResponseSet,

    comparator: 'index',
  });

  _.extend(EF.Collections, {
    ResponseSetCollection: ResponseSetCollection
  });

})(EF);
